import { useEffect } from "react";
import DataTable from "react-data-table-component";
import { useTxPending } from "./hooks/useTxPending";
import { customStyles2 } from "../../../util/TableStyles"
import { FlexGrid, Typography, useThemeProvider, Card, Skeleton, Button } from '@albo-ui/core'
import { noDataComponent, filterTxsPending, originTxsPending } from "../../../util/DataObject"
import GeneralConfirmDialog from "../../modals/confirm/GeneralConfirmDialog";
import CustomSearchBar from "../../elements/SearchBar/CustomSearchBar";
import PendingActionsIcon from '@mui/icons-material/PendingActions';
import Checkbox from "@mui/material/Checkbox";
import Box from "@mui/material/Box"

export const SpaceTxPending = ({ changeAlert, changeLoader, sectionData }: any) => {
    const { columns, data, item, isValid, loading: loadingTable, totalDocuments, dialogConfirm, typeSearch, origin, element, dialogText,
            saveData, onHandleSearch, onHandleSelected, onOpenConfirm, onCloseDialogConfirm, onConfirm } = useTxPending(changeAlert);
    const { theme } = useThemeProvider();

    useEffect(() => {
        saveData(sectionData);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        changeLoader(loadingTable);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [loadingTable]);
    
    return (
        <>
        <Card padding={4} flexDirection="column" fullWidth fullHeight alignItems="stretch" justifyContent="space-between" style={{ borderColor: theme.colors.manatee }}> 
            <FlexGrid container fullWidth justify="space-between" style={{ display: "flex" }}>
                <FlexGrid item justify="space-between" style={{ width: "60%" }}>
                    <Typography variant="h2" style={{display: "inline-flex", alignItems: "center", fontSize: "1.2rem"}}>
                        <PendingActionsIcon sx={{ marginRight: 1 }}/> Gestión de Tx´s Pendientes
                    </Typography>
                    <Box my={1} sx={{ fontStyle: 'italic', fontWeight: '500 !important' }}>
                        {totalDocuments} registro(s)
                    </Box>
                </FlexGrid>

                <FlexGrid item spacing={1} justify="flex-end" container fullWidth>
                    <CustomSearchBar 
                        field={true}
                        select={{
                            options: filterTxsPending,
                            text: "Tipo de búsqueda",
                            default: typeSearch,
                            options2: originTxsPending,
                            text2: "Origen",
                            default2: origin
                        }}
                        enableSearch={true}
                        refresh
                        onConfirm={onHandleSearch}
                    />
                </FlexGrid>
            </FlexGrid>
            <FlexGrid container spacing={2} fullWidth justify="flex-end" style={{ marginBottom: 25 }}>
                <Button disabled={!isValid} onClick={onOpenConfirm.bind(this, "rejected")} buttonType='secondary' size='large' style={{ height: 52, width: 150 }} >Rechazar</Button>
                <Button disabled={!isValid} onClick={onOpenConfirm.bind(this, "approve")} buttonType='primary' size='large' style={{ height: 52, width: 150 }} >Aprobar</Button>
            </FlexGrid>
            <FlexGrid container spacing={2} >
                {
                    loadingTable ?
                        <Skeleton width="100%" height="100px" />
                        :
                        <DataTable
                            columns={columns}
                            data={data}
                            customStyles={customStyles2}
                            noDataComponent={noDataComponent}
                            selectableRows
                            selectableRowsComponent={Checkbox}
                            onSelectedRowsChange={onHandleSelected}
                        />

                }
            </FlexGrid>
        </Card>
        <GeneralConfirmDialog 
            open={dialogConfirm.open}
            text={dialogText}
            onClose={onCloseDialogConfirm} 
            onConfirm={onConfirm} 
            item={item}
            element={element}
            width={"650px"}
        />
        </>

    )
}